<script>
  import uniqBy from 'lodash/uniqBy'

  export default {
    name: 'inputTag',

    props: {
      tags: {
        type: Array,
        default: () => []
      },
    },

    data() {
      return {
        innerTags: [...this.tags]
        // innerTags: [].concat(this._toConsumableArray(this.tags))
      }
    },

    watch: {
      tags() {
        this.innerTags = [...this.tags]
        // this.innerTags = [].concat(this._toConsumableArray(this.tags))
        this.innerTags = uniqBy([...this.tags], 'text');
      }
    },

    methods: {
      _toConsumableArray(arr) {
        if (Array.isArray(arr)) {
          for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
            arr2[i] = arr[i];
          }
          return arr2;
        } else {
          return Array.from(arr);
        }
      },

      remove(index) {
        this.innerTags.splice(index, 1)
        this.tagChange()
      },

      tagChange() {
        this.$emit('update:tags', this.innerTags)
      }
    }
  }
</script>


<template>
  <div class="vue-input-tag-wrapper">
    <div class="vue-input-tag-placeholder">
        Поиск в любом из этих мест
    </div>
    <div class="input-tag-list">
      <span v-for="(tag, index) in innerTags" :key="index" class="input-tag">
        <span>{{ $parent.formatDisplay(tag) }}</span>
        <a @click.prevent.stop="remove(index)" class="remove"></a>
      </span>
    </div>
  </div>
</template>

<style lang="scss">
  .vue-input-tag-wrapper {
    background-color: #fff;
    padding-top: 10px;

    .vue-input-tag-placeholder{
      width: 100%;
      padding: 10px;
      font-size: 13px;
      color: #999;
      padding-top: 0;
    }

    .input-tag-list{
      padding-left: 10px;
      border-bottom: 1px solid #e6e6e6;
      width: 100%;
      overflow: hidden;
      text-align: left;
      display: flex;
      flex-wrap: wrap;
    }

    .input-tag {
      background-color: #e7e7e7;
      color: #333;
      display: inline-block;
      font-size: 12px;
      font-weight: 400;
      margin-bottom: 10px;
      margin-right: 10px;
      padding: 3px 8px;
      span{
        display: inline-block;
        vertical-align: middle;
      }
      .remove {
        cursor: pointer;
        &:before {
          /* content: " \00d7"; */
          content: "";
          width: 20px;
          display: inline-block;
          vertical-align: middle;
          height: 20px;
          background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MCA1MCIgd2lkdGg9IjUwIiBoZWlnaHQ9IjUwIj4KICA8cGF0aCBmaWxsPSJub25lIiBzdHJva2U9IiMzMzMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2Utd2lkdGg9IjIiIGQ9Ik0xNiAzNGw5LTkgOS05bS0xOCAwbDkgOSA5IDkiLz4KPC9zdmc+");
                    background-position: 50% 50%;
                    background-size: 130%;
                    background-repeat: no-repeat;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/geo/input-tag.vue